import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  IoniconsOutline,
  StoreTemplateStatus,
  TemplateGroup,
  ViewMode,
} from '@pt/pt-models';
import { WidgetType } from 'it/primatoo/openapi/api/org/schemas/common/docs/WidgetType';

@Component({
  selector: 'pt-template-editor-group',
  templateUrl: `template-editor-group.component.html`,
  styleUrls: [`template-editor-group.component.scss`],
  // Encapsulation Emulated (default): niente ViewEncapsulation.None, niente
  // classi ng-bootstrap -> gli stili non si propagano nei widget figli.
})
export class TemplateEditorGroupComponent implements OnChanges {
  @Input() viewMode: ViewMode;
  @Input() status: StoreTemplateStatus;
  @Input() lockAcquired: boolean;
  @Input() groups: TemplateGroup[];
  @Input() selectedGroup: TemplateGroup;
  @Input() activeSmallView: boolean;
  @Input() activedEditWidgetId: number;
  @Output() changeTab = new EventEmitter<TemplateGroup>();

  public readonly ID_PREFIX = 'panel_';
  public enabledGroups: TemplateGroup[] = [];
  public disabledChangeGroup = false;
  public WidgetType = WidgetType;
  public IconExpand = IoniconsOutline.plus;
  public IconCollapse = IoniconsOutline.minus;
  public preliminaryRiskAssessmentGroupId?: number;

  /** id del gruppo aperto in lista / selezionato in tab; null = nessuno aperto */
  public openId: number | null = null;

  get isTab(): boolean {
    return this.viewMode !== 'LIST';
  }

  isOpen(group: TemplateGroup): boolean {
    return group?.id === this.openId;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.groups) {
      const groups: TemplateGroup[] = changes.groups.currentValue ?? [];
      this.enabledGroups = groups.filter((g) => g.enabled);
      // copia difensiva + ordinamento numerico stabile
      this.enabledGroups.forEach((group) => {
        group.widgets = [...group.widgets].sort((a, b) => a.order - b.order);
      });
      this.preliminaryRiskAssessmentGroupId =
        this.findPreliminaryRiskAssessmentGroup(this.enabledGroups);
    }

    if (changes.selectedGroup) {
      // l'apertura è guidata dal gruppo selezionato dal padre (sia list sia tab)
      this.openId = this.selectedGroup?.id ?? null;
    }

    if (changes.status) {
      this.disabledChangeGroup =
        this.status?.activedEditWidgetId !== null &&
        this.status?.activedEditWidgetId !== undefined;
    }
  }

  /** toggle di un pannello in modalità lista */
  toggle(group: TemplateGroup): void {
    // durante l'editing di un widget non si cambia gruppo
    if (this.disabledChangeGroup) {
      return;
    }
    if (this.isOpen(group)) {
      this.openId = null;
      this.changeTab.emit(undefined);
    } else {
      this.openId = group.id;
      this.changeTab.emit(group);
    }
  }

  private findPreliminaryRiskAssessmentGroup(
    enabledGroups: TemplateGroup[]
  ): number | undefined {
    for (const group of enabledGroups) {
      for (const widget of group.widgets) {
        if (widget.type === WidgetType.PRELIMINARY_RISK_ASSESSMENT) {
          return group.id;
        }
      }
    }
    return undefined;
  }
}
